export default ip => Number(ip.split('.').map((num) => (`000${num}`).slice(-3)).join(''));
